import { useContext } from "react";
import { AuthContext, Logo, ViewContext } from "@/components/lib";
import { useForm } from "react-hook-form";
import axios from "axios";
import Styles from "@/css/mainStyles";

export function InvitationAccepted() {
  const viewContext = useContext<any>(ViewContext);
  const authContext = useContext<any>(AuthContext);
  const otp = window.location.pathname.split("/").pop();

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({});

  const onSubmit = async (data: any) => {
    try {
      const res = await axios({
        method: "put",
        url: "/api/user/password/otp/" + otp,
        data
      });
      authContext.signin(res)
    } catch (error) {
      console.error(error);
      let message = error.response?.data
        ? error.response.data
        : error.message;
      if (message === "Validation Error in body" && error.response.data?.errors?.[0]?.message) {
        message = error.response.data.errors[0].message;
      }
      viewContext.notification.show(message, "error");
    }
  };

  return (
    <div className="flex flex-col gap-4 justify-center h-screen p-8 2xl:px-48 lg:w-1/2 text-center">
      <Logo className="w-80 lg:w-96 mx-auto my-5 lg:mb-12" />
      <h1 className="font-bold text-2xl lg:text-4xl">
        You’ve accepted our Invitation!
      </h1>
      <h2 className="mt-3 text-xl">Create a Password to continue</h2>
      <form
        className="flex flex-col gap-6 mt-7 text-left"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="flex flex-col flex-1 w-full">
          <label className={Styles.label}>Password</label>
          <input
            placeholder="Enter Password"
            type="password"
            className={Styles.input}
            {...register("password", { required: true })}
            style={errors.password && { border: "1px solid red" }}
          />
          {errors.password && <p className={Styles.error}>Password is required</p>}
        </div>
        <input type="submit" value="Continue" className={Styles.submitButton} />
      </form>
    </div>
  );
}
